<template>
  <div>
    <div class="mb-4 flex justify-between items-center">
      <h3 @click="expanded = !expanded" class="flex items-center gap-x-2 cursor-pointer">
        <span class="transition-transform duration-200" :class="{ 'transform rotate-180': expanded }">
          <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 256 256">
            <path
              fill="currentColor"
              d="M128 28a100 100 0 1 0 100 100A100.11 100.11 0 0 0 128 28Zm0 192a92 92 0 1 1 92-92a92.1 92.1 0 0 1-92 92Zm34.83-86.83a4 4 0 0 1 0 5.66l-32 32a4 4 0 0 1-5.66 0l-32-32a4 4 0 0 1 5.66-5.66L124 158.34V88a4 4 0 0 1 8 0v70.34l25.17-25.17a4 4 0 0 1 5.66 0Z"
            />
          </svg>
        </span>
        {{ c.name }}
      </h3>
      <div class="flex-shrink-0">
        <span v-if="c.checkable" class="p-1">
          <input
            type="checkbox"
            @change="emitChange($event, c.identifier)"
            :checked="isCookieSaved"
            aria-label="cookie type"
          />
        </span>
        <span v-else>
          {{ $t('Vždy aktivní') }}
          <input
            type="checkbox"
            class="hidden"
            @change="emitChange($event, c.identifier)"
            :checked="true"
            aria-label="cookie type"
            hidden="true"
          />
        </span>
      </div>
    </div>
    <div class="CollapsedContent" :class="expanded ? '-IsExpanded' : ''">
      <div v-html="c.content"></div>
      <div class="grid grid-cols-1 md:grid-cols-3 mt-4 gap-4">
        <div class="font-bold">{{ $t('Cookie name') }}</div>
        <div class="font-bold">{{ $t('Description') }}</div>
        <div class="font-bold">{{ $t('Expiration') }}</div>

        <div class="col-span-1 md:col-span-3 h-px bg-gray-200 my-px"></div>

        <template v-for="(cookieRow, key, index) in fullList[c.identifier]" :key="cookieRow.id">
          <div>{{ cookieRow.name }}</div>
          <div v-html="cookieRow.description"></div>
          <div>
            {{ cookieRow.expiration }}
          </div>

          <div v-if="index != totalRows - 1" class="col-span-1 md:col-span-3 h-px bg-gray-200 my-px"></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['c'],
  inject: ['fullList', 'currentCookies', 'currentCookiesState'],
  data() {
    return {
      expanded: false,
      selectedCookie: ''
    }
  },
  computed: {
    totalRows() {
      return Object.keys(this.fullList[this.c.identifier]).length
    },
    isCookieSaved() {
      return (
        this.currentCookies.value.includes(this.c.identifier) || this.currentCookiesState.value.includes('ACCEPT_ALL')
      )
    }
  },
  methods: {
    emitChange(e, name) {
      this.$emit('setCheckbox', name, e.target.checked)
    }
  },
  mounted() {
    // console.log(this.currentCookies)
    // console.log(this.currentCookiesState)
    // console.log(this.c.identifier)
  }
}
</script>

<style lang="scss" scoped>
@import '../../scss/components/_cookie-manager.scss';

.CollapsedContent {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);

  &.-IsExpanded {
    max-height: 1000px;
    transition: max-height 1s ease-in-out;
  }
}
</style>
